var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearchWhiteIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.59988 4.80039C6.94892 4.80039 4.7999 6.94942 4.7999 9.60039C4.7999 12.2514 6.94892 14.4004 9.59988 14.4004C12.2508 14.4004 14.3999 12.2514 14.3999 9.60039C14.3999 6.94942 12.2508 4.80039 9.59988 4.80039ZM2.3999 9.60039C2.3999 5.62394 5.62344 2.40039 9.59988 2.40039C13.5763 2.40039 16.7999 5.62394 16.7999 9.60039C16.7999 11.1554 16.3069 12.5953 15.4688 13.7722L21.2484 19.5519C21.717 20.0205 21.717 20.7803 21.2484 21.2489C20.7797 21.7175 20.0199 21.7175 19.5513 21.2489L13.7717 15.4693C12.5947 16.3074 11.1549 16.8004 9.59988 16.8004C5.62344 16.8004 2.3999 13.5768 2.3999 9.60039Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchWhiteIcon);
export default __webpack_public_path__ + "static/media/search-white-icon.afc9f956dfc3b75464230b4cf120bd0c.svg";
export { ForwardRef as ReactComponent };